import React from "react";
import MarksCalculatorComponent from "../MarksCalculator";
import { Helmet, HelmetProvider } from '@dr.pogodin/react-helmet';

export default function MarksCalculator(props) {
  return (
    <>
      <Helmet>
        <title>Free Student Grade Calculator & GPA Tracker | Student Tools Hub</title>
        <meta name="description" content="Calculate your grades and GPA instantly with our free student grade calculator. Track your academic performance and plan your study goals effectively." />
        <meta name="keywords" content="grade calculator, GPA calculator, student grades, academic tracker, marks calculator" />
        
        <meta property="og:title" content="Free Student Grade Calculator & GPA Tracker" />
        <meta property="og:description" content="Calculate your grades and GPA instantly with our free calculator." />
        <meta property="og:url" content="https://student-tools-hub.vercel.app/calculator" />
      </Helmet>
      
      <MarksCalculatorComponent {...props} />
    </>
  );
}
